<template>
  <footer>
    <w-flex align-center>
      <div class="xs4 pa1 footer-icons">
        <!-- <img :src="assetLogo" alt="ambrogio" class="footer-asset-icon" />
        <w-icon class="footer-mdi-icon">mdi mdi-robot</w-icon> -->
      </div>
      <div class="xs6 pa1">
        Portale Zcs Installatori
      </div>
      <div class="xs4 pa1 text-right">
        <span class="smallest">
          version {{ showInfo['git.branch'] }}/{{ showInfo['git.commit.id.abbrev'] }} at {{ showInfo['git.commit.time'] }}
          by {{ showInfo['git.commit.user.name'] }}
        </span>
      </div>
    </w-flex>

    <div v-if="debugEnabled" class="portal-debug">
      <div class="portal-debug__header">
        <span class="portal-debug__title">navigation timing</span>
      </div>
      <div v-if="result" class="portal-debug__row">
        <span class="portal-debug__url">{{ result.url }}</span>
        <span class="portal-debug__status ok">{{ result.status }}</span>
        <span class="portal-debug__dur">{{ result.duration }}ms</span>
        <span class="portal-debug__label">transferSize: <b>{{ result.transferSize }}b</b></span>
        <span class="portal-debug__label">decodedBody: <b>{{ result.decodedBodySize }}b</b></span>
        <span class="portal-debug__label">workerStart: <b>{{ result.workerStart }}ms</b></span>
        <span :class="['portal-debug__source', result.fromSW ? 'sw' : 'net']">
          {{ result.source }}
        </span>
      </div>
      <div v-else class="portal-debug__row">
        <span style="color:#555">PerformanceNavigationTiming not available</span>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
import assetLogo from "@/assets/ambrogio_robot_logo.png";

export default {
  name: 'MainFooter',

  data() {
    return {
      gitInfo: [],
      showInfo: {},
      result: null,
      assetLogo,
    };
  },

  computed: {
    debugEnabled() {
      return window.__env?.defaults?.showNetworkDebugger === true;
    },
  },

  created() {
    axios.get("git.txt", {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    }).then((resource) => {
      let newValues = resource.data.split(/\n/).map(line => {
        let split = line.split(/=/);
        let object = {};
        object['name'] = split[0];
        object['value'] = split[1];
        return object;
      }).filter(item => item['name']);
      this.gitInfo.splice(0, this.gitInfo.length, ...newValues);
      resource.data.split(/\n/).forEach(line => {
        let split = line.split(/=/);
        this.showInfo[split[0]] = split[1];
      });
    });

    if (this.debugEnabled) {
      this.readNavigationTiming();
    }
  },

  methods: {
    readNavigationTiming() {
      // PerformanceNavigationTiming: covers the actual HTML document navigation
      const nav = performance.getEntriesByType('navigation')[0];
      if (!nav) return;

      // transferSize === 0 && decodedBodySize > 0 → SW cache or browser cache
      // workerStart > 0 → definitely handled by a Service Worker
      const handledBySW = nav.workerStart > 0;
      const fromCache = nav.transferSize === 0 && nav.decodedBodySize > 0;

      let source;
      if (handledBySW && fromCache) source = 'SW cache';
      else if (handledBySW && !fromCache) source = 'SW → network';
      else if (fromCache) source = 'browser cache';
      else source = 'network';

      this.result = {
        url: location.pathname,
        status: nav.responseStatus ?? 200,
        duration: Math.round(nav.responseEnd - nav.startTime),
        transferSize: nav.transferSize,
        decodedBodySize: nav.decodedBodySize,
        workerStart: Math.round(nav.workerStart),
        source,
        fromSW: handledBySW,
      };
    },
  },
};
</script>

<style scoped>
footer {
  padding-top: 1em;
  padding-bottom: 1em;
  background-color: #1a1a1a;
  color: #f2f2f2;
}

.smallest {
  font-size: xx-small;
}

.footer-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-asset-icon {
  height: 24px;
  width: auto;
  opacity: 0.8;
}

.footer-mdi-icon {
  font-size: 24px;
  color: #f2f2f2;
  opacity: 0.8;
}

.portal-debug {
  font-family: monospace;
  font-size: 10px;
  border-top: 1px solid #333;
  padding: 4px 8px;
  color: #aaa;
}

.portal-debug__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.portal-debug__title {
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 9px;
}

.portal-debug__btn {
  background: none;
  border: 1px solid #444;
  color: #888;
  cursor: pointer;
  font-size: 9px;
  padding: 1px 6px;
  border-radius: 2px;
  font-family: monospace;
}

.portal-debug__btn:hover:not(:disabled) {
  color: #fff;
  border-color: #888;
}

.portal-debug__btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.portal-debug__row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.portal-debug__url    { color: #888; }
.portal-debug__dur    { color: #666; }
.portal-debug__label  { color: #555; }
.portal-debug__label b { color: #888; font-weight: normal; }

.portal-debug__status.ok  { color: #6dbf6d; }
.portal-debug__status.err { color: #e06c6c; }

.portal-debug__source.net { color: #5b9bd5; }
.portal-debug__source.sw  { color: #c9a84c; }
</style>
